module.exports = __webpack_public_path__ + "img/samsungpay.05b2605a.svg";